import { Component, OnDestroy, OnInit } from '@angular/core';
import { InvoiceSaleService } from './invoice-sale.service';
import onScan from 'onscan.js';
import { HttpErrorResponse } from '@angular/common/http';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ToastrService } from 'ngx-toastr';
import { Router, TitleStrategy } from '@angular/router';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { PositionUserResponse } from 'src/app/models/user.model';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel, ScenerySAT } from 'src/app/models/invoice-template.model';
import { InvoiceBackendResponse, InvoiceResponse, QuotationDataResponse, QuotationResponse } from 'src/app/models/invoice.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { concatMap, elementAt, filter } from 'rxjs/operators';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ProductService } from 'src/app/services/product.service';
import { SeriesResponse } from 'src/app/models/purchase.model';
import { TypesDoc } from 'src/app/models/typesdoc.model';
import { DateUtil } from 'src/app/common/util';
import { CompanyService } from 'src/app/services/company.service';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { TokenAlphaService } from 'src/app/services/token-alpha.service';
import { SalesAdministrativeService } from 'src/app/services/sales-administrative.service';
import { SaleOrderService } from 'src/app/services/sale-order.service';
import { OrderReservationService } from 'src/app/services/order-reservation.service';
import { ProductCpService } from 'src/app/services/product-cp.service';
import { GeographicRouteService } from 'src/app/services/geographic-route.service';
import { DestinationService } from 'src/app/services/destination.service';
import { Destination, WarehouseDestination } from 'src/app/models/destination.model';
import { AssociationExitNoteService } from 'src/app/services/association-exit-note.service';
import { PlaceService } from 'src/app/services/place.service';
import { Place } from 'src/app/models/place.model';
import { AssociationPlaceDestinationService } from 'src/app/services/association-place-destination.service';
import { VendorBillingNitService } from 'src/app/services/vendor-billing-nit.service';
import { getRequestAdvancePaymente } from './invoice-sale.utils';
import { BankService } from 'src/app/services/bank.service';
declare let $: any;

@Component({
	selector: 'app-invoice-sale',
	templateUrl: './invoice-sale.component.html',
	styleUrls: ['./invoice-sale.component.scss', '../../../../modals/modal-admin-area/modal-admin-area.component.scss']
})
export class InvoiceSaleComponent implements OnInit, OnDestroy {
	showInputInvoice = true;
	currentCompany: any = null;
	creatingNewWarehouse = false;
	//arrays initial data
	saving = false;
	vendors: any [] = [];
	cashiers = [];
	products = [];
	warehouses = [];
	banks = [];
	bankAccounts = [];
	cardTypes = [];
	//filter arrays
	filterWarehouses = [];
	filterClients = [];
	filterProducts = [];
	filterCashiers = [];
	filterAffiliates = [];
	pricesList = [];
	productsList = [];
	orders = [];
	searchingPrice = false;
	//properties of inputs of text type
	inputs = {
		warehouse: {
			value: null,
			verified: false,
			required: true,
			message: 'Campo requerido',
			class: 'fa-asterisk',
			color: 'danger',
			tooltip: 'status-warehouse',
			data: {
				id: null,
				place: null
			}
		}, client: {
			value: 'CF',
			verified: true,
			required: true,
			message: 'Campo requerido',
			class: 'fa-asterisk',
			color: 'success',
			tooltip: 'status-client',
			data: { id: null, code: null }
		}, cashier: {
			value: '',
			verified: false,
			required: true,
			message: 'Campo requerido',
			class: 'fa-asterisk',
			color: 'danger',
			tooltip: 'status-cashier',
			data: { id: null }
		}, product: {
			value: '',
			verified: false,
			required: false,
			message: '-',
			class: '',
			color: '',
			tooltip: 'status-product',
			data: null
		}, date: null,
		description: null,
		affiliate: {
			value: null,
			verified: false,
			required: true,
			message: 'Campo requerido',
			class: 'fa-asterisk',
			color: 'danger',
			tooltip: 'status-warehouse',
			data: null
		}
	};
	searchProduct = {
		quantity: 1,
		price: 0,
		total: null,
		stock: null,
		prices: [],
		series: new InputAutocompleteModel("", false, false, "", "fa-barcode", "", "", null, []),
		selectedSerie: null,
		inTransit: null,
		inReserved: null,
		stockTemp: null,
		inTransitTemp: null,
		inReservedTemp: null
	}
	//properties of order select
	ordersSelected = [];
	order = false;
	totals = {
		toPay: {
			sum: 0,
			order: 0,
			productList: 0
		},
		paid: 0,
		creditClient: 0,
		creditAvailable: 0
	}
	dollar = false;
	payment = {
		selected: "cash",
		methods: {
			cash: {
				amount: null, cashier: this.inputs.cashier.value, id: 1, validated: false, title: 'Efectivo', class: 'bx bx-money', changed: false
			},
			credit: { amount: null, id: 3, validated: false, title: 'Crédito', class: 'fa fa-file-invoice-dollar' },
			check: { amount: null, id: 2, bank: -1, date: null, number: null, name: null, validated: false, title: 'Cheque', class: 'fa fa-money-check-dollar' },
			card: { amount: null, id: 4, bank: -1, reference: null, authorization: null, validated: false, title: 'Tarjeta de credito/debito', class: 'bx bx-credit-card' },
			transfer: { amount: null, id: 5, bank: -1, reference: null, advance: null, validated: false, title: 'Transferencia', class: 'fa fa-money-bill-trend-up' },
			pointsRedemption: { amount: null, id: 9, validated: false, title: 'Cambio de Puntos', class: 'fa fa-cubes-stacked' },
			advance: {
				amount: null,
				id: 10,
				advanceId: null,
				advance: null,
				validated: false,
				title: 'Anticipo',
				class: 'fa-solid fa-hand-holding-dollar'
			},
		},
		total: 0
	}
	alertMessage = "";
	amountRest = 0.00;
	amountChange = 0.00;
	options = {
		selected: "invoice",
		invoice: { serie: null, number: null, type: undefined, types: [], email: null },
		doc: { number: null },
		electronicInvoice: true,
		exportInvoice: false,
		sendEmail: true,
		download: true,
		normalDownload: true
	}
	dataExport = {
		consignatario: null,
		direccionConsignatario: null,
		incoterm: null,
		codigoConsignatario: null,
		nombreComprador: null,
		direccionComprador: null,
		codigoComprador: null,
		otrasReferencias: null,
		nombreExportador: null,
		codigoExportador: null
	}
	//Variables that helps to the focus on inputs
	focusWarehouse = false;
	focusClient = false;
	focusProduct = false;
	focusCashier = false;
	focusAffiliate = false;
	enabledOrders = -1;
	isAffiliate = true;
	affiliatePoints = 0.0;
	stringAffiliate = "";
	factorDolar = 1;
	permissions = {
		checkProductExistence: true
	}
	timeout = null;
	success = "";
	permissionType = PermissionTypeEnum;
	allowOverdraft = false;
	invoiceTemp = null;
	tokenButton = new ButtonLoading("btn-success", false, "VALIDAR", "fa-fingerprint");
	token = null;
	checkTokenAlpha = true;
	stateCheckbox = false;
	checkListOwnProducts = false;
	productsCpVendor = [];
	checkGeographicMap = false;
	destinationsWarehouse: WarehouseDestination[] = []
	lastDestinationWarehouse: WarehouseDestination = null;
	checkAdministration = false;
	loadingConfig = false;
	places: Place[] = [];
	placesRecord: { [key: number]: Place } = {};
	destinations: Destination[] = [];
	destinationsRecord: { [key: number]: Destination } = {};
	destinationSet = new Set<number>([]);
	vendorBillingNits: any[] = [];
	vendorBillingNitId: number = null;
	loadingVendorBillingNits: boolean = false;
	showVendorBillingNitModal: boolean = false;
	companyIsAdmin: boolean = false;
	hasExtraTaxRegularConfig:boolean = false;
	showClientCfModal: boolean = false;
	areOtherData: boolean = false;
	advancesClient: any[] = [];
	loadingAdvancesClient = false;

	constructor(
		private service: InvoiceSaleService,
		private toastService: ToastrService,
		private router: Router,
		private authService: AuthenticationService,
		private roleService: RolesAndPermissionsService,
		private productService: ProductService,
		private createService: TemplateInvoice,
		private companyService: CompanyService,
		private salesAdministrativeService: SalesAdministrativeService,
		private orderReservationService: OrderReservationService,
		private tokenService: TokenAlphaService,
		private productCpService: ProductCpService,
		private geographicRouteService: GeographicRouteService,
		private destinationService: DestinationService,
		private associationExitNoteService: AssociationExitNoteService,
		private placeService: PlaceService,
		private associationPlaceDestinationService: AssociationPlaceDestinationService,
		private vendorBillingNitService: VendorBillingNitService,
		private bankService : BankService
	) {
	}

	ngOnDestroy(): void {
		onScan.detachFrom(document);
	}

	getTypesDoc(selected) {
		this.service.getTypesdoc(selected).subscribe({
			next: (response: ResponseObject) => {
				let typesdoc = response.data as TypesDoc[];
				console.log(typesdoc);
				this.options.invoice.types = typesdoc;
				let newTypesdoc = typesdoc.filter((invoice) =>
					invoice.predetermined === 1
				);
				if (newTypesdoc.length === 1) {
					this.options.invoice.type = newTypesdoc[0].typeDoc;
				}
				console.log(this.options.invoice.type);
			},
			error: (error: HttpErrorResponse) => {
				this.toastService.error(error.error.message);
			}
		}
		);
	}

	activateScanBarcode() {
		var temp = document['scannerDetectionData'];
		if (temp === undefined)
			onScan.attachTo(document, {
				suffixKeyCodes: [13], // enter-key expected at the end of a scan
				reactToPaste: false, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
				onScan: (sCode, iQty) => {
					this.codeBar(sCode, iQty);
				}
			});
	}

	codeBar(sCode: string, iQty: string) {
		if (this.inputs.warehouse.verified) {
			if (!document.activeElement.classList.contains("series")) {
				this.service.getProductsFilteredByFavorite(sCode,this.inputs.warehouse.data?.id).subscribe(
					(response) => {
						var tempProductFindList = Object(response)['data'];
						if (tempProductFindList.length === 1) {
							this.inputs.product.value = "";
							const elements = document.getElementsByClassName('suggestions');
							for (let i = 0; i < elements.length; i++) {
								const element = elements[i];
								element.classList.remove('suggestions-show');
							}
							clearTimeout(this.timeout);
							var tempProductFind = tempProductFindList[0];
							this.inputs.product.data = tempProductFind;
							this.addProduct();
						} else {
							this.toastService.info(`El producto con código de barras ${sCode} no existe en la base de datos`);
						}
					},
					(error) => {
						console.log("Failed to get product list. More about the error: " + error);
					}
				);
			} else {
				this.toastService.info("Busca serie");
			}
		}
	}

	getInitialData_v2() {
		var currentUserPosition = this.authService.getUserPosition();
		this.currentCompany = JSON.parse(this.authService.getCurrentCompany());
		this.service.getProductsFilteredByFavorite('',this.inputs.warehouse.data?.id).pipe(
			concatMap((response) => {
				this.products = Object(response)['data'];
				this.filterProducts = this.products;
				return this.service.getClients();
			}),
			concatMap((response) => {
				this.vendors = Object(response)['data'];
				this.filterClients = this.vendors;
				this.verifiedInput({ target: document.getElementById('client-input') }, 'client');
				return this.service.getWarehouses();
			}),
			concatMap((response) => {
				let warehouseTemp = Object(response)['data'];
				warehouseTemp.forEach((w) => {
					if (w.logo)
						w.logo = "https://s3.amazonaws.com/rrhh-images/warehouse/logos/" + w.logo;
				});

				this.warehouses = warehouseTemp;
				let idUser = JSON.parse(this.authService.getCurrentUser()).id;
				return this.roleService.getUserPosition(idUser);
			}),
			concatMap((response: ResponseObject) => {
				let userPosition = response.data as PositionUserResponse[];
				let permissionWarehouse = [];
				if (userPosition.length > 0) {
					userPosition.forEach((u) => {
						permissionWarehouse.push(u.warehouse);
					});
					this.warehouses = this.warehouses.filter(bodega => permissionWarehouse.includes(bodega.id));
				} else {
					console.log("No tiene permisos");
				}
				this.filterWarehouses = this.warehouses;
				if (this.filterWarehouses.length == 1) {
					this.inputs.warehouse.value = this.filterWarehouses[0].name;
					this.inputs.warehouse.class = "fa-check";
					this.inputs.warehouse.verified = true;
					this.inputs.warehouse.data = this.filterWarehouses[0];
					this.getTypesDoc(this.filterWarehouses[0].id);
					this.loadProductsByWarehouse();
				}
				return this.service.getCash();
			}),
			concatMap((response) => {
				this.cashiers = Object(response)['data'];
				if (currentUserPosition) {
					const unique = new Set<number>();
					currentUserPosition.forEach((elemento) => {
						unique.add(elemento.cash);
					});
					const filter = Array.from(unique);
					this.cashiers = this.cashiers.filter(cash => filter.includes(cash.id));
					this.filterCashiers = this.cashiers;
					if (this.cashiers.length == 1) {
						const input = document.getElementById('cashier-input') as HTMLInputElement;
						input.value = this.cashiers[0].name;
						this.verifiedInput({ target: input }, 'cashier');
					}
				}
				return this.service.getBanks();
			}),
			concatMap((response) => {
				this.banks = Object(response)['data'];
				return this.service.getAllOrders();
			}),
			concatMap((response) => {
				this.orders = Object(response)['data'];
				return this.service.getBankActiveAccounts();
			}),
			concatMap((response) => {
				this.bankAccounts = Object(response)['data'];
				return this.companyService.getConfigVerifyInventory();
			}),
			concatMap((response) => {
				this.allowOverdraft = Object(response)['data'];
				return this.companyService.checkCompanyConfigTokenAlpha();
			}),
			concatMap((response) => {
				this.checkTokenAlpha = response.data;
				return this.companyService.checkCompanyConfigGeographicMap();
			}),
			concatMap((response) => {
				this.checkGeographicMap = response.data;
				return this.companyService.checkCompanyConfigListOwnProducts();
			}),
			concatMap((response) => {
				this.checkListOwnProducts = response.data;
				return this.companyService.checkCompanyConfigAdministration();
			}),
			concatMap((response) => {
				this.checkAdministration = response.data;
				if (this.checkAdministration === true) {
					this.options.selected = 'administrative';
				}
				this.loadingConfig = true;
				return this.service.getCardTypes();
			}),
			concatMap((response) => {
				this.cardTypes = Object(response)['data'];
				return this.companyService.checkCompanyConfigAdministrative();
			}),
			concatMap((response) => {
				this.companyIsAdmin = Object(response)['data'];
				return this.companyService.checkCompanyConfigRegularExtraTax();
			}),
			concatMap((response) => {
				this.hasExtraTaxRegularConfig = Object(response)['data'];
				return this.destinationService.getDestinationsActive(true);
			}),
			concatMap((response) => {
				this.destinations = Object(response)['data'] ?? [];
				this.destinationsRecord = this.destinations.reduce((acc, item) => {
					acc[item.id] = item;
					return acc;
				}, {} as Record<number, Destination>);
				return this.placeService.getActivePlaces();
			})
		).subscribe(
			(response) => {
				this.places = Object(response)['data'] ?? [];
				this.placesRecord = this.places.reduce((acc, item) => {
					acc[item.id] = item;
					return acc;
				}, {} as Record<number, Place>);

			},
			(error) => {
				this.toastService.error("Error al obtener los datos iniciales");
			}
		);
	}

	ngOnInit(): void {
		document.addEventListener('click', this.handleDocumentClick);
		var currentCompany = JSON.parse(this.authService.getCurrentCompany());
		this.getInitialData_v2();
		this.inputs.date = this.getTodayDate();
		this.activateScanBarcode();
	}

	getConfigListOwnProducts() {
		this.companyService.checkCompanyConfigListOwnProducts().subscribe({
			next: (response: ResponseObject) => {
				this.checkListOwnProducts = response.data;
			},
			error: (error: HttpErrorResponse) => {
				this.toastService.error(error.error.message);
			}
		});
	}

	getProductsCpByVendor() {
		if (!this.inputs.client.data.id || !this.checkListOwnProducts)
			return;

		this.productCpService.getProducsCPByVendorId(this.inputs.client.data.id).subscribe({
			next: (response: ResponseObject) => {
				this.productsCpVendor = response.data;
				this.filterProductsCp();
			},
			error: (error: HttpErrorResponse) => {
				this.toastService.error(error.error.message);
			}
		});
	}

	getClientByPlace() {
		if (this.inputs.warehouse.data != null) {
			// buscar associaciones de ubicacion y destinos
			this.destinationSet = new Set<number>([]);
			this.associationPlaceDestinationService.getAssociationsByPlace(this.inputs.warehouse.data.place).subscribe({
				next: (resp: ResponseObject) => {
					const associations: any[] = resp.data || [];
					this.destinationSet = new Set<number>(
						associations.map(item => item.destinationId)
					);
					this.searchClient('');
				},
				error: (error) => {
					console.error(error);
					// this.toastService.error('Error al obtener asociaciones de la ubicación');
				}
			});
		} else { 
			this.destinationSet = new Set<number>([]);
			this.searchClient(''); 
		}

	}

	normaliceAssociationsPlace() {

	}

	filterProductsCp() {
		if (!this.checkListOwnProducts || !this.productsCpVendor || this.productsCpVendor.length === 0) {
			this.filterProducts = this.products;
			return;
		}
		const allowedProductIds = this.productsCpVendor.map(p => p.productId);
		this.filterProducts = this.products.filter(prod => allowedProductIds.includes(prod.id));
	}


	handleInput(event: any, type: string) {
		this.focusWarehouse = type == 'warehouse';
		this.focusClient = type == 'client';
		this.focusProduct = type == 'product';
		this.focusCashier = type == 'cashier';
		this.focusAffiliate = type == 'affiliate';
		const inputField = event.target as HTMLInputElement;
		const inputValue = inputField.value;
		const input = event.target as HTMLInputElement;
		const parentInput = input.parentElement;
		const divElements = parentInput.getElementsByClassName('suggestions')[0];
		divElements.classList.add('suggestions-show');
		if (type == 'warehouse') {
			clearTimeout(this.timeout);
			this.inputs.warehouse.class = "typing";
			this.timeout = setTimeout(() => {
				/* this.service.getWarehouseByClue(inputValue).subscribe(
					(response) => {
						this.filterWarehouses = Object(response)['data'];
						if (this.filterWarehouses.length == 0) {
							var tempFilter = this.warehouses.filter((warehouse) =>
								warehouse.name.toLowerCase().includes(inputValue.toLowerCase()) || warehouse.id == parseInt(inputValue)
							);
							if (tempFilter.length == 0) {
								this.changeStatusInput(null, null, 0, 'warehouse');
							} else {
								this.filterWarehouses = tempFilter;
								this.inputs.warehouse.class = "bx bx-list-check";
							}
						} else {
							this.inputs.warehouse.class = "bx bx-list-check";
						}
					}, (error) => {
						console.log("Fail to get filter warehouses, " + error);
					}); */
				this.filterWarehouses = this.warehouses.filter((w) => {
					return w.id == inputValue || w.name.toLowerCase().includes(inputValue.toLowerCase()) || w.nit == inputValue
				})
				if (this.filterWarehouses.length == 0) {
					this.changeStatusInput(null, null, 0, 'warehouse');
				} else {
					this.inputs.warehouse.class = "bx bx-list-check";
				}
			}, 500);
		} else if (type == 'client') {
			clearTimeout(this.timeout);
			this.inputs.client.class = "typing";
			this.timeout = setTimeout(() => {
				this.searchClient(inputValue);
			}, 1000);
		} else if (type == 'product') {
			clearTimeout(this.timeout);
			this.inputs.product.class = "typing";
			this.timeout = setTimeout(() => {
				if (inputValue != "" && inputValue.length > 2) {
					this.inputs.product.class = "loading";
					this.service.getProductsFilteredByFavorite(inputValue,this.inputs.warehouse.data?.id).subscribe(
						(response) => {
							let productsResponse = Object(response)['data'] || [];

							if (this.checkListOwnProducts && this.productsCpVendor?.length > 0) {
								const allowedIds = this.productsCpVendor.map(p => p.productId);
								productsResponse = productsResponse.filter(p => allowedIds.includes(p.id));
							}

							this.filterProducts = productsResponse;
							if (this.filterProducts.length == 0) {
								const baseList = (this.checkListOwnProducts && this.productsCpVendor?.length > 0)
									? this.products.filter(p =>
										this.productsCpVendor.some(v => v.productId === p.id)
									)
									: this.products;

								this.filterProducts = baseList.filter((product) =>
									product.name.toLowerCase().includes(inputValue.toLowerCase()) || product.id == parseInt(inputValue)
									|| product.code?.toLowerCase() == inputValue.toLowerCase() || product.barCode?.toLowerCase() == inputValue.toLowerCase()
								);
								if (this.filterProducts.length == 0) {
									this.changeStatusInput(null, null, 0, 'product');
								} else {
									this.inputs.product.class = "bx bx-list-check";
								}
							} else {
								if (inputValue != '') {
									this.inputs.product.class = "bx bx-list-check";
								} else {
									this.inputs.product.class = "";
								}
							}
						}, (error) => {
							console.log("Fail to get filter products, " + error);
						});
				} else {
					if (this.checkListOwnProducts && this.productsCpVendor?.length > 0) {
						const allowedIds = this.productsCpVendor.map(p => p.productId);
						this.filterProducts = this.products.filter(p => allowedIds.includes(p.id));
					} else {
						this.filterProducts = this.products;
					}
				}
			}, 200);
		} else if (type == 'cashier') {
			this.filterCashiers = this.cashiers.filter((cashier) =>
				(cashier.id + " - " + cashier.name).toLowerCase().includes(inputValue.toLowerCase())
			)
		} else if (type == 'affiliate') {
			clearTimeout(this.timeout);
			this.inputs.affiliate.class = "typing";
			// Make a new timeout set to go off in 1000ms (1 second)
			this.timeout = setTimeout(() => {
				this.service.getAffiliateByClue(inputValue).subscribe(
					(response) => {
						this.filterAffiliates = Object(response)['data'];
						if (this.filterAffiliates.length == 0) {
							this.changeStatusInput(null, null, 0, 'affiliate');
						} else {
							this.inputs.affiliate.class = "bx bx-list-check";
						}
					}, (error) => {
						console.log("Fail to get filter warehouses, " + error);
					});
			}, 500);
		}
	};

	validateNit(nit: string): boolean {
		const expresionRegular = /^\d{8}$/;
		return expresionRegular.test(nit);
	}

	validateCui(cui: string): boolean {
		const expresionRegular = /^\d{13}$/;
		return expresionRegular.test(cui);
	}

	/**
	 * Function that verifies if an input value is empty, correct or erroneous.
	 * @param event An event of the input to verify
	 * @param type An string, 'warehouse' if the input is for select warehouse or 'client' if the input is for select client
	 */
	verifiedInput(event: any, type: string) {
		const inputValue = (event.target as HTMLInputElement).value;
		clearTimeout(this.timeout);
		if (inputValue == '') {
			if (type == 'warehouse') {
				this.changeStatusInput(null, null, 2, 'warehouse');
			} else if (type == 'client') {
				this.changeStatusInput(null, null, 2, 'client');
			} else if (type == 'product') {
				this.changeStatusInput(null, null, 2, 'product');
			} else if (type == 'cashier') {
				this.changeStatusInput(null, null, 2, 'cashier');
			}
		} else {
			switch (type) {
				case 'warehouse':
					{
						/* this.service.getWarehouseByClue(inputValue).subscribe(
							(response) => {
								this.filterWarehouses = Object(response)['data'];
								if (this.filterWarehouses.length == 1) {
									this.changeStatusInput(this.filterWarehouses[0], this.filterWarehouses[0].name, 1, 'warehouse');
								} else {
									var tempFilter = this.warehouses.filter((warehouse) =>
										warehouse.name.toLowerCase().includes(inputValue.toLowerCase()) || warehouse.id == parseInt(inputValue)
									);
									if (tempFilter.length != 1) {
										this.changeStatusInput(null, null, 0, 'warehouse');
									} else {
										this.changeStatusInput(tempFilter[0], tempFilter[0].name, 1, 'warehouse');
									}
								}
							}, (error) => {
								console.log("Fail to get filter warehouses, " + error);
							}); */
						this.filterWarehouses = this.warehouses.filter((w) => {
							return w.id == inputValue || w.name.toLowerCase().includes(inputValue.toLowerCase()) || w.nit == inputValue
						});
						if (this.filterWarehouses.length == 1) {
							this.changeStatusInput(this.filterWarehouses[0], this.filterWarehouses[0].name, 1, 'warehouse');
						} else {
							this.changeStatusInput(null, inputValue, 2, 'warehouse');
						}
						break;
					}
				case 'client': {
					this.searchClient(inputValue);
					break;
				}
				case 'product': {
					let temp: any = this.products.filter((product) =>
						product.name.toLowerCase().includes(inputValue.toLowerCase()) || product.id == parseInt(inputValue)
					);
					if (temp.length == 1) {
						this.changeStatusInput(temp[0], (temp[0].barCode ? temp[0].barCode + ' - ' : '') + temp[0].name, 1, 'product');
						this.validateProduct(temp[0]);
					} else {
						this.changeStatusInput(null, null, 0, 'product');
					}
					break;
				}
				case 'cashier': {
					let temp: any = this.cashiers.filter((cashier) =>
						(cashier.id + " - " + cashier.name).toLowerCase().includes(inputValue.toLowerCase())
					);
					if (temp.length == 1) {
						this.changeStatusInput(temp[0], temp[0].name, 1, 'cashier');
					} else {
						this.changeStatusInput(null, null, 0, 'cashier');
					}
					break;
				}
				case 'affiliate': {
					this.service.getAffiliateByClue(inputValue).subscribe(
						(response) => {
							var temp = Object(response)['data'];
							if (temp.length != 1) {
								this.changeStatusInput(null, null, 0, 'affiliate');
							} else {
								this.changeStatusInput(temp[0], this.inputs.affiliate.value, 1, 'affiliate');
							}
						}, (error) => {
							console.log("Fail to get filter warehouses, " + error);
						});
				}
				default:
					break;
			}
		}
	}

	/*searchClient(inputValue: string) {
		let temp: any = this.vendors.filter((client) => {
			if (this.inputs.warehouse.data && this.inputs.warehouse.data.place) {
				if (client.code.toLowerCase() == 'vcf') {
					return inputValue.toLowerCase() == 'cf' || inputValue.toLowerCase() == 'c/f' || inputValue.toLowerCase() == '';
				} else {
					return (client.name.toLowerCase().includes(inputValue.toLowerCase()) || (client.id + "") == (inputValue) ||
						client.nit.toLowerCase().includes(inputValue.toLowerCase())) && this.destinationSet.has(client.place);
				}
			} else {
				if (inputValue.toLowerCase() == 'cf' || inputValue.toLowerCase() == 'c/f') {
					return client.code.toLowerCase() == 'vcf';
				} else {
					return client.name.toLowerCase().includes(inputValue.toLowerCase()) || (client.id + "") == (inputValue) ||
						client.nit.toLowerCase().includes(inputValue.toLowerCase());
				}
			}
		});

		this.filterClients = temp;
		if (temp.length == 1) {
			this.changeStatusInput(temp[0], temp[0].nit + " - " + temp[0].name, 1, 'client');
		} else {
			if (temp.length == 0) {
				this.inputs.client.class = "typing";
				this.service.getClientsByNit(inputValue).subscribe({
					next: (response: ResponseObject) => {
						if (response) {
							this.vendors.push(response.data);
							this.changeStatusInput(response.data, response.data.nit + " - " + response.data.name, 1, 'client');
						} else {
							this.toastService.info("El cui enviado no es valido");
							this.changeStatusInput(null, inputValue, 0, 'client');
						}
					},
					error: (error: HttpErrorResponse) => {
						this.changeStatusInput(null, inputValue, 0, 'client');
						this.toastService.error(error.error.message);
					}
				});
			} else {
				this.inputs.client.class = "fa-list";
				this.inputs.client.verified = false;
				this.inputs.client.data = null;
			}
		}
	}*/

	searchClient(inputValue: string) {
		const search = inputValue.trim().toLowerCase();

		let temp: any = this.vendors.filter((client) => {

			const code = client.code?.trim().toLowerCase() || '';
			const nit = client.nit?.trim().toLowerCase() || '';
			const name = client.name?.trim().toLowerCase() || '';
			const contactCellphone = client.contactCellphone?.trim().toLowerCase() || '';

			// El celular solamente participa en la búsqueda cuando:
			// 1. El cliente tiene NIT CF/C/F
			// 2. NO es el cliente especial VCF
			const canSearchBycontactCellphone =
				code !== 'vcf' &&
				(nit === 'cf' || nit === 'c/f') &&
				contactCellphone !== '';

			const matchesClient =
				name.includes(search) ||
				String(client.id) === search ||
				nit.includes(search) ||
				(canSearchBycontactCellphone && contactCellphone.includes(search));

			if (this.inputs.warehouse.data && this.inputs.warehouse.data.place) {

				// Cliente especial VCF
				if (code === 'vcf') {
					return search === 'cf' ||
						search === 'c/f' ||
						search === '';
				}

				return matchesClient && this.destinationSet.has(client.place);

			} else {

				// Si escribe exactamente CF, conserva tu comportamiento actual:
				// devuelve solamente el VCF.
				if (search === 'cf' || search === 'c/f') {
					return code === 'vcf';
				}

				return matchesClient;
			}
		});

		this.filterClients = temp;

		if (temp.length == 1) {

			this.changeStatusInput(
				temp[0],
				this.getClientDisplayName(temp[0]),
				1,
				'client'
			);

		} else if (temp.length == 0) {

			this.inputs.client.class = "typing";

			this.service.getClientsByNit(inputValue).subscribe({
				next: (response: ResponseObject) => {

					if (response?.data) {

						this.vendors.push(response.data);

						this.changeStatusInput(
							response.data,
							this.getClientDisplayName(response.data),
							1,
							'client'
						);

					} else {

						this.toastService.info("El cui enviado no es valido");
						this.changeStatusInput(null, inputValue, 0, 'client');

					}
				},
				error: (error: HttpErrorResponse) => {

					this.changeStatusInput(null, inputValue, 0, 'client');
					this.toastService.error(error.error.message);

				}
			});

		} else {

			this.inputs.client.class = "fa-list";
			this.inputs.client.verified = false;

		}
	}

	getClientDisplayName(client: any): string {
		if (!client) {
			return '';
		}

		const nit = client.nit?.trim() || '';
		const code = client.code?.trim().toUpperCase() || '';
		const contactCellphone = client.contactCellphone?.trim() || '';

		let text = `${nit} - ${client.name}`;

		const isCf =
			nit.toUpperCase() === 'CF' ||
			nit.toUpperCase() === 'C/F';

		// Mostrar celular solamente:
		// - si es CF
		// - si tiene celular
		// - si NO es VCF
		if (isCf && code !== 'VCF' && contactCellphone) {
			text += ` - cel. ${contactCellphone}`;
		}

		const destination = this.destinationsRecord[client.place];

		if (destination) {
			text += ` / ${destination.name}`;
		}

		return text;
	}

	/**
	 * Function that shows visually status of the current warehouse/client
	 * @param selected An object that represents the selected value, null if the entered value does not match any warehouse/client.
	 * @param newValue An string that represents the new value of the input, null if the entered value does not need to be change.
	 * @param status An integer, 1 if the selected value is OK, 2 if is blank and 0 if does not mach any warehouse/client
	 * @param type An string, that represents if the input is for 'warehouse' or 'client'
	 */
	changeStatusInput(selected: any, newValue: string, status: number, type: string) {
		let tempInput;
		if (type == 'warehouse') {
			tempInput = this.inputs.warehouse;
		} else if (type == 'client') {
			tempInput = this.inputs.client;
		} else if (type == 'product') {
			tempInput = this.inputs.product;
		} else if (type == 'cashier') {
			tempInput = this.inputs.cashier;
		} else if (type == 'affiliate') {
			tempInput = this.inputs.affiliate;
		}
		tempInput.verified = status == 1;
		if (status == 1) {
			tempInput.data = selected;
			tempInput.value = newValue;
			tempInput.color = "success";
			tempInput.class = 'fa-circle-check';
			if (type == 'product') {
				this.validateProduct(selected);
				this.changeTooltip(tempInput.tooltip, 'Producto seleccionado correctamente!');
			} else if (type == 'warehouse') {
				this.options.electronicInvoice = selected.gfaceEnabled;
				if(this.companyIsAdmin){
					this.options.electronicInvoice = true;
				}
				this.options.download = selected.downloadEnabled;
				this.service.getTypesdoc(selected.id).subscribe({
					next: (response: ResponseObject) => {
						let typesdoc = response.data as TypesDoc[];
						this.options.invoice.types = typesdoc;
						let newTypesdoc = typesdoc.filter((invoice) =>
							invoice.predetermined === 1
						);
						if (newTypesdoc.length === 1) {
							this.options.invoice.type = newTypesdoc[0].typeDoc;
						}
					},
					error: (error: HttpErrorResponse) => {
						this.toastService.error(error.error.message);
					}
				}
				);
				this.loadProductsByWarehouse();
				this.changeTooltip(tempInput.tooltip, 'Bodega seleccionada correctamente!');
				this.getDestinationWarehouse();
				this.getClientByPlace();
			} else if (type == 'client') {
				this.options.invoice.email = selected.contactMail;
				this.service.validateAffiliate(selected.id).subscribe(
					(response) => {
						this.isAffiliate = Object(response)['data'];
						this.service.getAffiliateByClue('').subscribe({
							next: (response: ResponseObject) => {
								console.log(selected.id);
								
								this.filterAffiliates = response.data ?? [];
								console.log(this.filterAffiliates);
								
								const affiliate = this.filterAffiliates.find(item => item.vendorId === selected.id);
								this.inputs.affiliate.data = affiliate? affiliate : null;
							},
							error: (error: any) => {
								console.log(error);
							}
						});

						if (this.isAffiliate) {
							this.service.getAffiliatePointsByVendorId(selected.id).subscribe({
								next: (response: ResponseObject) => {
									this.affiliatePoints = response.data;
								},
								error: (error: any) => {
									console.log(error);
									this.affiliatePoints = 0;
								}
							});
						}
					}, (error) => {
						console.log("Fail to get " + error);
					}
				)
				this.getCreditClient();
				this.getProductsCpByVendor();
				this.getVendorBillingNits(selected.id);
				this.getAdvancesClient(selected.id);
				this.changeTooltip(tempInput.tooltip, 'Cliente seleccionado correctamente!');
			} else if (type == 'cashier') {
				this.checkCashValidate();
				this.changeTooltip(tempInput.tooltip, 'Caja seleccionada correctamente!');
			} else if (type == 'affiliate') {
				this.changeTooltip(tempInput.tooltip, 'Afiliado seleccionado correctamente!');
			}
		} else {
			tempInput.data = null;
			tempInput.color = 'danger';
			if (status == 0) {
				tempInput.class = 'fa-xmark';
				var message = (type == 'product') ? 'Ingresa un producto válido' : 'Ingresa un cliente válido o crea uno nuevo';
				this.changeTooltip(tempInput.tooltip, (type == 'warehouse') ? 'Ingresa una bodega válida o crea una nueva' : message);
			} else {
				tempInput.class = 'fa-asterisk';
				this.changeTooltip(tempInput.tooltip, 'Campo requerido, no puede quedar vacio');
			}
			if (type == 'cashier') {
				this.checkCashValidate();
			}
			if (type == 'client') {
				this.vendorBillingNits = [];
				this.vendorBillingNitId = null;

				this.advancesClient = [];
				this.payment.methods.advance.advanceId = null;
				this.payment.methods.advance.advance = null;
				this.payment.methods.advance.amount = null;
				this.payment.methods.advance.validated = false;

				this.updateChange();
			}
		}
	}

	/**
	 * Function thats change message on specified tooltip
	 * @param idTooltip An string that represents the id of the element that wants change message on tooltip
	 * @param message An string that represents the new message that will show on tooltip
	 */
	changeTooltip(idTooltip: string, message: string) {
		/* const tooltip = Tooltip.getInstance("#" + idTooltip);
		tooltip.setContent({ '.tooltip-inner': message }) */
	}

	private handleDocumentClick = (event: Event) => {
		const cashier = document.getElementById('cashier') as HTMLInputElement;
		if (this.focusCashier) {
			if (!(event.target instanceof HTMLElement) || !cashier.contains(event.target)) {
				this.focusCashier = false;
			}
		}
	};

	submitForm() {
		return false;
	}

	validatePrice() {
		const checkPrice = document.getElementById("checkPrice") as HTMLInputElement;
		for (let price of this.products) {
			if (price.name == checkPrice.value || price.id == checkPrice.value) {
				(checkPrice.parentNode.children[1] as HTMLButtonElement).disabled = false;
				return price;
			}
		}

		(checkPrice.parentNode.children[1] as HTMLButtonElement).disabled = true;
	}

	checkPrice() {
		const checkPrice = document.getElementById("checkPrice") as HTMLInputElement;
		var temp = this.validatePrice();
		checkPrice.value = "";
		(checkPrice.parentNode.children[1] as HTMLButtonElement).disabled = true;
		for (let price of this.pricesList) {
			if (temp.id == price.code) {
				return false;
			}
		}
		this.pricesList.push({ name: temp.name, code: temp.id, list: "Lista básica" });
	}

	selectPrice(priceObject: any) {
		console.log(priceObject);
	}

	filterSeries() {
		this.searchProduct.series.filterElements = this.searchProduct.series.total.filter((series) => {
			return series.seriesProduct.toLowerCase().includes(this.searchProduct.series.value.toLowerCase())
		});
		this.searchProduct.series.data = null;
		if (this.searchProduct.series.filterElements.length == 0) {
			this.searchProduct.series.class = "fa-xmark";
		} else {
			this.searchProduct.series.class = "fa-list";
		}
	}

	selectSeries(series: SeriesResponse) {
		this.searchProduct.series.class = "fa-circle-check";
		this.searchProduct.series.value = series.seriesProduct;
		this.searchProduct.series.data = series;
		this.searchProduct.quantity = 1;
	}

	// Validate product
	validateProduct(product: any) {
		this.searchProduct.prices = [];
		this.searchProduct.stock = null;
		this.searchProduct.price = 0;
		this.service.getPriceFilteredPlace(product.id, this.inputs.warehouse.data.id).subscribe(
			(response) => {
				if (Object(response)['data'].length > 0) {
					this.searchProduct.price = Object(response)['data'][0].price;
					product['pricelist'] = Object(response)['data'][0].listData;
					product['price'] = Object(response)['data'][0].price;
					this.searchProduct.prices = Object(response)['data'];
					this.searchProduct.total = this.searchProduct.quantity * this.searchProduct.price;
				}
			},
			(error) => {
				console.log('Fail to obtain price data, ' + error);
			}
		)
		if (product.type != 's') {
			if (this.options.selected == "saleOrder") {

				this.service.getExistencePlusRecipeOnlyProduct(product.id).subscribe(
					(response) => {
						this.searchProduct.stock = Object(response)['data'] - this.getProductsAddedOfId(product.id);
						this.getQuantities();
					},
					(error) => {
						console.log('Fail to obtain stock data, ' + error);
					}
				);
			} else {
				this.service.getExistencePlusRecipe(this.inputs.warehouse.data.id, product.id).subscribe(
					(response) => {
						this.searchProduct.stock = Object(response)['data'] - this.getProductsAddedOfId(product.id);
						// this.getQuantities();
					},
					(error) => {
						console.log('Fail to obtain stock data, ' + error);
					}
				);
			}
		} else {
			this.searchProduct.stock = '-9999';
		}
		this.productService.getAssociateSeriesSale(product.id, this.inputs.warehouse.data.id).subscribe({
			next: (response: ResponseObject) => {
				this.searchProduct.series.total = response.data.filter(totalSeriesElement =>
					!this.productsList.some(alreadySeriesElement => {
						if (!alreadySeriesElement.series || totalSeriesElement.id === alreadySeriesElement.series.id) {
							return true;
						}
					}
					));
				this.searchProduct.series.filterElements = this.searchProduct.series.total;
			},
			error: (error: HttpErrorResponse) => {
				// nothing
			}
		})
	}

	getProductsAddedOfId(productId: number) {
		for (let i = 0; i < this.productsList.length; i++) {
			const element = this.productsList[i];
			if (element.id == productId) {
				return element.quantity;
			}
		}
		return 0;
	}

	addProduct() {
		this.filterProducts = this.products;
		var tempProduct = this.inputs.product.data;
		var total = this.searchProduct.quantity * this.searchProduct.price;
		var inputTemp = new InputAutocompleteModel("", "", true, "Serie", "fa-barcode text-info", "", "", null, []);
		this.productsList.push(
			{
				id: tempProduct.id, name: tempProduct.name, quantity: this.searchProduct.quantity,
				price: this.searchProduct.price, total: total, data: tempProduct, input: inputTemp,
				series: (this.searchProduct.series.data) ? this.searchProduct.series.data : null
			});
		this.searchProduct.series = new InputAutocompleteModel("", false, false, "", "fa-barcode", "", "", null, []);
		this.updateTotalAloneProducts();
		this.checkCashValidate();
		this.inputs.product.class = '';
		setTimeout(() => {
			this.inputs.product.value = "";
			this.inputs.product.data = null;
			this.inputs.product.verified = false;
			this.scrollToEnd();
		}, 100);
	}

	get validateDisableWarehouse(): boolean {
		if (this.productsList.length > 0) {
			return true;
		}
		return false;
	}

	checkCashValidate() {
		if (this.inputs.cashier.verified && this.payment.methods.cash.amount > 0 && this.payment.methods.cash.amount != '') {
			this.payment.methods.cash.validated = true;
		} else {
			this.payment.methods.cash.validated = false;
		}
		this.updateChange();
	}

	scrollToEnd() {
		const miDiv = document.getElementById('miDiv') as HTMLDivElement;
		const con1 = document.getElementById('product-div') as HTMLDivElement;
		const con = document.getElementById('container-sale') as HTMLDivElement;
		const titlePage = document.getElementById('title-page') as HTMLDivElement;
		const titleProductH = document.getElementById('title-product-h') as HTMLHeadingElement;
		miDiv.scrollTo(0, miDiv.scrollHeight);
		con1.scrollIntoView();
		if (con.clientWidth < 575) {
			con.scrollTop = con.scrollTop - titlePage.clientHeight + titleProductH.clientHeight + 10;
		} else {
			con.scrollTop = con.scrollTop - titlePage.clientHeight;
		}
	}

	changeValue(product: any, type: string) {
		product.total = product.quantity * product.price;
		this.updateTotalAloneProducts();
	}

	getPaymentMethods() {
		return Object.keys(this.payment.methods).map(key => ({
			key,
			...this.payment.methods[key]
		}));
	}

	updateTotalAloneProducts() {
		var newTotal = 0;
		this.productsList.forEach(element => {
			newTotal += element.price * element.quantity;
		});
		this.totals.toPay.productList = newTotal;
		this.updateChange();
	}

	deleteProduct(id: string) {
		for (let i = 0; i < this.productsList.length; i++) {
			if (id == this.productsList[i].id) {
				this.productsList.splice(i, 1);
				break;
			}
		}
		this.updateTotalAloneProducts();
		this.checkCashValidate();
	}

	changeCashOrCredit(event: any, type: string) {
		var val = (event.target as HTMLInputElement).value;
		if (val != '' && parseFloat(val) > 0) {
			if (type == 'cash') {
				this.payment.methods.cash.changed = true;
				this.checkCashValidate();
			} 
			else if (type == "pointsRedemption") {
				this.payment.methods.pointsRedemption.validated = true;
			}
			else {
				this.payment.methods.credit.validated = true;
			}
		} else {
			if (type == 'cash') {
				this.payment.methods.cash.validated = false;
			} 
			else if (type == "pointsRedemption") {
				this.payment.methods.pointsRedemption.validated = true;
			}
			else {
				this.payment.methods.credit.validated = false;
			}
		}
		this.updateChange();
	}

	updateChange() {
		this.totals.toPay.sum = this.totals.toPay.order + this.totals.toPay.productList;
		if (this.totals.toPay.sum != 0 && !this.payment.methods.cash.changed) {
			if (this.totals.toPay.sum - this.getTotalOthersMethods() >= 0) {
				this.payment.methods.cash.amount = this.totals.toPay.sum - this.getTotalOthersMethods();
			} else {
				this.payment.methods.cash.amount = 0;
			}
		}
		this.updateTotalPaid();
		if (this.totals.toPay.sum - this.totals.paid > 0) {
			this.amountRest = Math.max(0, Math.round((this.totals.toPay.sum - this.totals.paid) * 100) / 100);
			this.amountChange = 0;
		}
		else {
			this.amountRest = 0;
			this.amountChange = Math.max(0, Math.round((this.totals.paid - this.totals.toPay.sum) * 100) / 100);
		}
		this.validateAmountRest();
	}

	getTotalOthersMethods() {
		var temp = Object.keys(this.payment.methods).map(key => ({
			key,
			...this.payment.methods[key]
		}));
		var newTotal = 0;
		temp.forEach((methodPay) => {
			if (methodPay.validated && methodPay.key != 'cash' && methodPay.key != 'pointsRedemption')
				newTotal += methodPay.amount;
		})
		return newTotal;
	}

	updateTotalPaid() {
		var temp = Object.keys(this.payment.methods).map(key => ({
			key,
			...this.payment.methods[key]
		}));
		var newTotal = 0;
		temp.forEach((methodPay) => {
			if (methodPay.validated && methodPay.id!=9)
				newTotal += methodPay.amount;
		})
		this.totals.paid = newTotal;
	}

	payWithCheck() {
		const mountCheck = (document.getElementById('mount-check') as HTMLInputElement).value;
		const bankCheck = (document.getElementById('bank-check') as HTMLInputElement).value;
		const dateCheck = (document.getElementById('date-check') as HTMLInputElement).value;
		const noCheck = (document.getElementById('no-check') as HTMLInputElement).value;
		const noAccountCheck = (document.getElementById('no-account-check') as HTMLInputElement).value;
		if (bankCheck != '-1' && parseFloat(mountCheck) > 0 && dateCheck.length >= 1
			&& parseInt(noCheck) > 0 && (noAccountCheck != null && noAccountCheck != '')) {
			this.payment.methods.check.validated = true;
		} else {
			this.payment.methods.check.validated = false;
		}
		this.updateChange();
	}

	validateAmountRest() {
		const totalOthers = Math.round(this.getTotalOthersMethods() * 100) / 100;
		const totalToPay = Math.round(this.totals.toPay.sum * 100) / 100;

		if (totalOthers > totalToPay) {
			this.alertMessage = "El valor ingresado sobrepasa el monto a pagar";
			return false;
		} else {
			this.alertMessage = "";
			return true;
		}
	}


	payWithCard() {
		const mountCard = (document.getElementById('mount-card') as HTMLInputElement).value;
		const referencyCard = (document.getElementById('referency-card') as HTMLInputElement).value;
		const typeCard = (document.getElementById('type-card') as HTMLInputElement).value;
		const authorizationCard = (document.getElementById('authorization-card') as HTMLInputElement).value;
		if (referencyCard != '' && parseFloat(mountCard) > 0 && authorizationCard != '' && typeCard != '-1') {
			this.payment.methods.card.validated = true;
		} else {
			this.payment.methods.card.validated = false;
		}
		this.updateChange();
	}

	payWithTransfer() {
		const mountTransfer = (document.getElementById('mount-transfer') as HTMLInputElement).value;
		const accountTransfer = (document.getElementById('account-transfer') as HTMLInputElement).value;
		const noTransfer = (document.getElementById('no-transfer') as HTMLInputElement).value;
		const advanceTransfer = (document.getElementById('advance-transfer') as HTMLInputElement).value;
		if (accountTransfer != '-1' && parseFloat(mountTransfer) > 0 && parseInt(noTransfer) > 0 &&
			parseFloat(advanceTransfer) > 0) {
			this.payment.methods.transfer.validated = true;
		} else {
			this.payment.methods.transfer.validated = false;
		}
		this.updateChange();
	}

	payWithAdvance(): void {

		const method = this.payment.methods.advance;

		const advance = method.advance;
		const amount = Number(method.amount ?? 0);

		if (!advance || amount <= 0) {
			method.validated = false;
			this.updateChange();
			return;
		}

		const availableAmount = Number(advance.amount ?? 0);

		if (amount > availableAmount) {

			method.validated = false;

			this.toastService.warning(
				'El monto ingresado no puede ser mayor al anticipo disponible'
			);

			this.updateChange();
			return;
		}

		method.validated = true;

		this.updateChange();
	}

	/**
	 * Move the content to the destination div taking into account the floating div of the page title
	 * @param destiny An string that represents the content the user wants to go to.
	 */
	sendToDiv(destiny: string) {
		const scrollContainer = document.getElementById('container-sale') as HTMLDivElement;
		const divDestiny = document.getElementById(destiny) as HTMLDivElement;
		const titlePage = document.getElementById('title-page') as HTMLDivElement;
		divDestiny.scrollIntoView();
		scrollContainer.scrollTop = scrollContainer.scrollTop - titlePage.clientHeight;
	}

	addOrder(event: any, orderFilter: any) {
		orderFilter.selected = event.target.checked;

		this.ordersSelected = this.orders.filter((order) =>
			order.selected == true
		);

		if (this.ordersSelected.length > 0) {
			this.enabledOrders = orderFilter.clientData.id;
			this.service.getDetailOrder(orderFilter.id).subscribe(
				(response) => {
					orderFilter['detail'] = Object(response).data;
					orderFilter['detail'].forEach(product => {
						product['price'] = 0;
						product['total'] = 0;
					});
					orderFilter['total'] = 0;
					this.getTotalOrder(orderFilter);
					this.checkCashValidate();
				},
				(error) => {
					console.log('Fail to get detail ' + error);
				}
			)
		} else {
			this.enabledOrders = -1;
			this.getTotalOrder(orderFilter);
			this.checkCashValidate();
		}

	}

	clearOrder() {
		this.orders.forEach(element => {
			element.selected = false;
		});
		this.ordersSelected = [];
	}

	getTotalOrder(order: any): number {
		var total = 0;
		order.detail.forEach(product => {
			total += product.toDeliver * product.price;
			product.total = product.toDeliver * product.price;
		});
		order.total = total;
		this.getTotalOrders();
		return total;
	}

	getTotalOrders() {
		var total = 0;
		this.ordersSelected.forEach((order) => {
			total += order.total;
		});
		this.totals.toPay.order = total;
		this.updateChange();
		this.checkCashValidate();
	}

	formatTimestampToDateString(timestamp: number): string {
		const date = new Date(timestamp); // Crear un objeto Date a partir de la marca de tiempo
		const options: Intl.DateTimeFormatOptions = {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric',
			timeZoneName: 'short'
		};
		return date.toLocaleDateString('es-ES', options); // Ajusta el idioma y las opciones según tus preferencias
	}

	formatTimestampToDateStringShort(timestamp: number): string {
		const date = new Date(timestamp); // Crear un objeto Date a partir de la marca de tiempo
		const options: Intl.DateTimeFormatOptions = {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		};
		return date.toLocaleDateString('es-ES', options); // Ajusta el idioma y las opciones según tus preferencias
	}

	getTodayDate() {
		const today = new Date();

		// Formatea la fecha en el formato "YYYY-MM-DD"
		const year = today.getFullYear();
		const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
		const day = String(today.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}

	getPaymentArray() {
		var pm = this.getPaymentMethods();
		var paymentsAdded = [];
		pm.forEach((payment) => {
			if (payment.validated) {
				if (payment.amount > 0) {
					switch (payment.id) {
						case 1:
							paymentsAdded.push({ amount: payment.amount, paymentType: payment.id });
							break;
						case 2:
							paymentsAdded.push({
								amount: payment.amount,
								paymentType: payment.id,
								advanceAmount: 0,
								bank: parseInt(payment.bank),
								checkDate: this.parseDateToMilliseconds(payment.date),
								checkNumber: payment.number,
								name: payment.name
							});
							break;
						case 3:
							paymentsAdded.push({
								amount: payment.amount,
								paymentType: payment.id
							});
							break;
						case 4:
							paymentsAdded.push({
								amount: payment.amount,
								paymentType: payment.id,
								authorization: payment.authorization,
								cardType: parseInt(payment.bank),
								reference: payment.reference
							});
							break;
						case 5:
							paymentsAdded.push({
								amount: payment.amount,
								paymentType: payment.id,
								advanceAmount: payment.advance,
								bankAccountId: parseInt(payment.bank),
								transferNumber: payment.reference
							});
							break;
						case 9:
							if (this.affiliatePoints<payment.amount) {
								this.toastService.warning("La cantidad de Puntos disponibles es meyor a la cantidad ingresada");
								throw new Error("Error en la Cantidad de Puntos");
							}
							paymentsAdded.push({
								amount: payment.amount,
								paymentType: payment.id
							});
							break;
						case 10:
							paymentsAdded.push({
								amount: payment.amount,
								paymentType: payment.id,

								advanceId:
									payment.advance?.docId ??
									payment.advance?.id,

								advanceSourceType:
									payment.advance?.sourceType
							});

							break;
						default:
							break;
					}
				}
			}
		});
		return paymentsAdded;
	}

	saveInvoice() {
		if (this.vendorBillingNits.length > 0 && this.vendorBillingNitId == null ) {
			this.toastService.warning("Debes seleccionar un NIT de facturación");
			return;
		}
		var paymentsAdded = this.getPaymentArray();
		var invoice = {
			clientId: null,
			vendorBillingNitId: null,
			warehouseId: null,
			series: null,
			number: null,
			lot: null,
			cash: null,
			description: this.inputs.description ? this.inputs.description : '',
			date: this.parseDateToMilliseconds(this.inputs.date),
			accountingDate: this.parseDateToMilliseconds(this.inputs.date),
			invoice: this.options.selected == 'invoice' || this.options.selected == 'administrative',
			detail: [],
			payment: paymentsAdded,
			gface: this.options.electronicInvoice,
			gfaceByEmail: this.options.sendEmail && this.options.electronicInvoice,
			gfaceEmail: this.options.invoice.email,
			gfaceDownload: true,
			isExport: this.options.exportInvoice,
			isDolar: this.dollar,
			//normalDownload: this.options.normalDownload && this.options.download && this.options.selected == 'invoice',
			normalDownload: false,
			providerInvoiceId: null,
			discount: 0,
			total: Math.round(this.totals.toPay.sum * 100) / 100,
			type: this.options.invoice.type, //solucion alternativa HAY QUE CAMBIARLA!
			dataExport: [],
			affiliate: "",
			reserved: this.stateCheckbox
		};

		invoice.clientId = this.inputs.client.data.id;
		invoice.warehouseId = this.inputs.warehouse.data.id;
		invoice.cash = (this.inputs.cashier.data.id) ? this.inputs.cashier.data.id : null;
		invoice.series = this.options.invoice.serie;
		//invoice.number = invoice.invoice ? $scope.invoiceData.number : $scope.invoiceData.numberR;
		invoice.number = invoice.invoice ? this.options.invoice.number : this.options.doc.number;
		//invoice.lot = $scope.invoiceData.lot;
		invoice.lot = null;
		invoice.affiliate = this.inputs.affiliate.data == null ? "" : this.inputs.affiliate.data.id; 
		if (this.vendorBillingNits.length > 0 && this.vendorBillingNitId != null) {
			invoice['vendorBillingNitId'] = this.vendorBillingNitId;
		}
		
		this.ordersSelected.forEach((orderProduct) => {
			orderProduct.detail.forEach((product) => {
				var tmpProduct = {
					detailId: product.id,
					productId: product.productData.id,
					quantity: product.toDeliver,
					//priceListId: product.product.priceEdited ? null : product.product.priceListId,
					priceListId: null,
					price: product.price,
					descriptionProduct: product.productData.name,
					canBeExempt: false,
					exemptTextId: product.productData.exemptTextId
				};
				invoice.detail.push(tmpProduct);
			})
		});

		this.productsList.forEach((product) => {
			var tmpProduct = {
				productId: product.id,
				quantity: product.quantity,
				price: product.price,
				descriptionProduct: product.name,
				canBeExempt: (product.canBeExempt) ? product.canBeExempt : false,
				exemptTextId: product.data.exemptTextId,
				comment: product.comment
			};
			invoice.detail.push(tmpProduct);
		});

		if (this.options.exportInvoice) {
			invoice.dataExport.push(this.dataExport);
		}

		if (this.options.selected == 'quotation') {
			this.saving = true;
			this.service.saveQuotation(invoice).subscribe(
				(response: ResponseObject) => {
					this.success = "Cotización guardada!";
					/* if (Object(response)['data'].downloadLink) {
						this.service.downloadPdf(this.service.getUrlApi() + "api/downloads/" + Object(response)['data'].downloadLink)
							.subscribe((data) => {
								// Crea un objeto Blob con los bytes del PDF
								const blob = new Blob([data], { type: 'application/pdf' });
								// Crea una URL de objeto para el Blob
								const url = window.URL.createObjectURL(blob);

								// Crea un enlace temporal para descargar el PDF
								const a = document.createElement('a');
								a.href = url;
								a.download = 'cotizacion-' + Object(response)['data'].documentId + '.pdf';
								a.style.display = 'none';
								document.body.appendChild(a);
								// Inicia la descarga del PDF y luego elimina el enlace
								a.click();
								window.URL.revokeObjectURL(url);
								document.body.removeChild(a);
							});
					} */
					this.createQuotationPDF(response.data as QuotationResponse);
					this.saving = false;
					clearTimeout(this.timeout);
					this.timeout = setTimeout(() => {
						this.success = "";
						this.refresh();
					}, 3000);
				},
				(error) => {
					this.toastService.error("Error al guardar la cotización");
					this.saving = false;
				}
			);
		} else if (this.options.selected == 'administrative') {
			if (this.payment.methods.credit.validated && this.checkTokenAlpha) {
				this.showTokenAuthorization(invoice);
			} else {
				this.createSaleAdministrative(invoice)
			}
		} else if (this.options.selected == 'saleOrder') {
			this.createSaleOrder(invoice)
		} else if (this.options.selected == 'advancePayment') {
			this.createAdvancePayment(invoice)
		} else {
			if (this.payment.methods.credit.validated && this.checkTokenAlpha) {
				this.showTokenAuthorization(invoice);
			} else {
				this.createSale(invoice)
			}
		}
		this.stateCheckbox = false;
	}

	showTokenAuthorization(invoice) {
		this.invoiceTemp = invoice;
	}

	hideTokenAuthorization() {
		this.token = null;
		this.invoiceTemp = null;
	}

	validateToken() {
		if (this.tokenButton.loading) {
			return;
		}
		this.tokenButton.loading = true;
		this.tokenService.useToken(this.token).subscribe({
			next: (response: ResponseObject) => {
				this.tokenButton.loading = false;
				if (response.data) {
					this.token = null;
					if (this.options.selected == 'administrative') {
						this.createSaleAdministrative(this.invoiceTemp)
					} else {
						this.createSale(this.invoiceTemp);

					}
				} else {
					this.toastService.error("El token no es válido. Contacta con el administrador o genera un nuevo.");
				}
			},
			error: (error) => {
				this.tokenButton.loading = false;
				this.toastService.error("Error al validar el token");
			}
		})
	}

	createSaleAdministrative(invoice) {
		this.saving = true;
		this.invoiceTemp = null;
		this.areOtherData = false;
		this.salesAdministrativeService.saveInvoice(invoice).subscribe(
			(response: ResponseObject) => {
				this.success = "Factura guardada!";
				this.saveGeographicLocation(response.data);
				this.addClientInvoiceToSeriesProduct(response.data);
				this.createInvoicePDFs(response.data);
				this.saving = false;
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.success = "";
					this.refresh();
				}, 3000);
			},
			(error) => {
				this.toastService.error(error.error.message);
				this.saving = false;
			}
		);
	}

	createSaleOrder(invoice) {
		this.saving = true;
		this.invoiceTemp = null;
		this.orderReservationService.saveSaleOrder(invoice).subscribe({
			next: (response: ResponseObject) => {
				this.toastService.success("Pedido creado", "Exito");
				this.success = "Pedido Guardado";
				this.saving = false;
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.success = "";
					this.refresh();
				}, 3000);
			},
			error: (error: HttpErrorResponse) => {
				this.toastService.error("Error al crear pedido", "Error");
				this.saving = false;
			}
		});
	}

	createAdvancePayment(invoice) {
		if (invoice.payment.length == 0 ) {
			this.toastService.warning('Debe selecciona una tipo de pago para el anticipo.');
			return;
		}

		if (invoice.payment.length > 1 ) {
			this.toastService.warning('Solo se permite un tipo de pago pare ingresar el anticipo.');
			return;
		}

		const request = getRequestAdvancePaymente(invoice, this.dollar? 1 : 0, this.inputs.warehouse.data.id);

		this.service.postCreateAdvacenPayment(request).subscribe({
			next: (response: ResponseObject) => {
				this.createAdvancePDF(response.data);

				this.toastService.success("Anticipo Ingresado Correctamente", "Exito");
				this.success = "Anticipo Guardado";
				this.saving = false;
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.success = "";
					this.refresh();
				}, 3000);
			},
			error: (error: HttpErrorResponse) => {
				this.toastService.error("Error al crear anticipo", "Error");
				this.saving = false;
			}
		});
		
	}

	createSale(invoice) {
		this.saving = true;
		this.invoiceTemp = null;
		this.service.saveInvoice(invoice).subscribe(
			(response: ResponseObject) => {
				this.success = "Factura guardada!";
				this.saveGeographicLocation(response.data);
				this.saveAssociationExitNote(response.data);
				this.addClientInvoiceToSeriesProduct(response.data);
				this.createInvoicePDF(response.data.data);
				this.saving = false;
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.success = "";
					this.refresh();
				}, 3000);
			},
			(error) => {
				this.toastService.error(error.error.message);
				this.saving = false;
			}
		);
	}

	async createQuotationPDF(quotationPDF: any) {
		var selected = this.inputs.warehouse.data;
		var invoiceDataNew = this.getQuotationData(quotationPDF, selected);
		var configurationInvoice = new ConfigurationInvoice(selected['nfact'], selected['fcolor'], selected['scolor'], selected['tcolor'], selected['slogan']);
		if (this.inputs.warehouse.data['logo']) {
			this.createService.selectTemplate(configurationInvoice, invoiceDataNew, this.inputs.warehouse.data['logo']);
		} else {
			if (this.currentCompany) {
				if (!this.currentCompany.companyLogo.includes("/images/company-avatar2.png")) {
					this.createService.selectTemplate(configurationInvoice, invoiceDataNew, this.currentCompany.companyLogo);
				} else {
					this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
				}
			} else {
				this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
			}
		}
	}

	async createAdvancePDF(advancePdf: any) {
		var selected = this.inputs.warehouse.data;
		var invoiceDataNew = this.getAdvancePdfData(advancePdf);
		var configurationInvoice = new ConfigurationInvoice(1, selected['fcolor'], selected['scolor'], selected['tcolor'], selected['slogan']);
		if (this.inputs.warehouse.data['logo']) {
			this.createService.selectTemplate(configurationInvoice, invoiceDataNew, this.inputs.warehouse.data['logo']);
		} else {
			if (this.currentCompany) {
				if (!this.currentCompany.companyLogo.includes("/images/company-avatar2.png")) {
					this.createService.selectTemplate(configurationInvoice, invoiceDataNew, this.currentCompany.companyLogo);
				} else {
					this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
				}
			} else {
				this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
			}
		}
	}

	addClientInvoiceToSeriesProduct(invoice) {
		var series = [];
		this.productsList.forEach((product) => {
			if (product.series) {
				series.push(product.series.id);
			}
		});
		if (series.length > 0) {
			this.productService.addClientInvoiceToSeriesProduct(invoice.data.invoiceData.id, series).subscribe({
				next: (response: ResponseObject) => {
					this.toastService.success("Se agregaron correctamente las series!")
				},
				error: (error: HttpErrorResponse) => {
					this.toastService.error(error.error.message);
				}
			})
		}
	}

	private createInvoicePDFs(responseData: any): void {
		// Si viene otherData, descarga solo ese PDF
		if (responseData?.otherData) {
			this.areOtherData = true;
			this.createInvoicePDF(responseData.otherData);
		}
		// Si NO viene otherData, descarga la factura normal
		else if (responseData?.data) {
			this.areOtherData = false;
			this.createInvoicePDF(responseData.data);
		}
		this.areOtherData = false;
	}

	async createInvoicePDF(invoiceData: any) {
		const selected =invoiceData?.invoiceData?.warehouseData ??this.inputs.warehouse.data;
		var invoiceDataNew = this.getInvoiceData(invoiceData, selected);
		var configurationInvoice = new ConfigurationInvoice(selected['nfact'], selected['fcolor'], selected['scolor'], selected['tcolor'], selected['slogan']);
		if (this.inputs.warehouse.data['logo']) {
			this.createService.selectTemplate(configurationInvoice, invoiceDataNew, this.inputs.warehouse.data['logo']);
		} else {
			if (this.currentCompany) {
				if (!this.currentCompany.companyLogo.includes("/images/company-avatar2.png")) {
					this.createService.selectTemplate(configurationInvoice, invoiceDataNew, this.currentCompany.companyLogo);
				} else {
					this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
				}
			} else {
				this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
			}
		}
	}

	getAdvancePdfData(advanceData: any) {
		var templateGenerated = new InvoiceTemplateModel();
		templateGenerated.warehouse = advanceData.warehouse;
		var response = advanceData;
		templateGenerated.type = InvoiceType.ADVANCE;
		templateGenerated.currency = 0;
		templateGenerated.client.name = (response.name) ? response.name : '';
		templateGenerated.client.nit = (response.nit) ? response.nit : '';
		templateGenerated.client.address = (response.address) ? response.address : "";
		templateGenerated.invoice.date = (response.date) ? new Date(response.date).toISOString().split("T")[0] : "";
		templateGenerated.invoice.number = "";
		templateGenerated.invoice.serial = "";
		templateGenerated.seller.name = this.currentCompany.companyName;
		templateGenerated.seller.city = "";
		templateGenerated.seller.state = '';
		templateGenerated.seller.street = (templateGenerated.warehouse?.address) ? templateGenerated.warehouse.address : "";
		templateGenerated.seller.nit = (templateGenerated.warehouse?.nit) ? templateGenerated.warehouse.nit : "";
		templateGenerated.total = response.totalCost;
		templateGenerated.totalAdvance = response.totalAdvance;
		response.details.forEach(element => {
			templateGenerated.items.push(new InvoiceItemModel(element.quantity, element.price, element.productName));
		});
		templateGenerated.setPhrase(new ScenerySAT(-1, -1));
		return templateGenerated;
	}

	getQuotationData(invoiceData: QuotationResponse, warehouse) {
		var templateGenerated = new InvoiceTemplateModel();
		templateGenerated.warehouse = warehouse;
		var response = invoiceData.data as QuotationDataResponse;
		var invoice = invoiceData.data.cotizacionData;
		templateGenerated.type = InvoiceType.QUOTATION;
		templateGenerated.currency = invoice.currency;
		templateGenerated.client.name = (invoice.name) ? invoice.name : '';
		templateGenerated.client.nit = (invoice.nit) ? invoice.nit : '';
		templateGenerated.client.address = (response.gfaceData.buyerAddress) ? response.gfaceData.buyerAddress : "";
		templateGenerated.invoice.date = (invoice.creationDate) ? new Date(invoice.creationDate).toISOString().split("T")[0] : "";
		templateGenerated.invoice.number = invoice.id ? invoice.id + "" : "";
		templateGenerated.invoice.serial = "";
		templateGenerated.seller.name = this.currentCompany.companyName;
		templateGenerated.seller.city = "";
		templateGenerated.seller.state = '';
		templateGenerated.seller.street = (templateGenerated.warehouse?.address) ? templateGenerated.warehouse.address : "";
		templateGenerated.seller.nit = (templateGenerated.warehouse?.nit) ? templateGenerated.warehouse.nit : "";
		templateGenerated.total = invoice.totalCost;
		response.cotizacionDetailData.forEach(element => {
			templateGenerated.items.push(new InvoiceItemModel(element.quantity, element.price, element.descriptionProduct, element.extraTax));
		});

		if (this.inputs.warehouse.data.id == 3282 || this.inputs.warehouse.data.id == 3569) {
			templateGenerated.setPhrase(new ScenerySAT(0, 0));

		} else {
			if (invoiceData.taxRegime !== null && invoiceData.taxRegime !== undefined) {
				var scenary = invoiceData.taxRegime - 1 >= 0 ? invoiceData.taxRegime - 1 : 1;
				templateGenerated.setPhrase(new ScenerySAT(0, scenary));
			}
		}
		return templateGenerated;
	}

	getInvoiceData(invoiceData: any, warehouse) {
		var templateGenerated = new InvoiceTemplateModel();
		templateGenerated.warehouse = warehouse;
		if (invoiceData.gfaceData) {
			var response = invoiceData as InvoiceResponse;
			var invoice = invoiceData.gfaceData;
			templateGenerated.type = InvoiceType.NORMAL;
			if(invoice.type != null && invoice.type == "FCAM"){
				templateGenerated.type = InvoiceType.FCAM;
			}
			if(this.companyIsAdmin && !this.areOtherData){
				templateGenerated.type = InvoiceType.BACKEND;
			}else if(this.companyIsAdmin && this.areOtherData){
				templateGenerated.type = InvoiceType.NORMAL;
			}
			templateGenerated.currency = response.invoiceData.currency;
			templateGenerated.client.name = (invoice.buyerName) ? invoice.buyerName : '';
			templateGenerated.client.nit = (invoice.buyerNit) ? invoice.buyerNit : '';
			templateGenerated.client.address = (response.invoiceData.clientData.address) ? response.invoiceData.clientData.address : "";
			templateGenerated.certifier.signature = (invoice.signature) ? invoice.signature : '';
			templateGenerated.certifier.date = (invoice.certificationDate) ? invoice.certificationDate : "";
			templateGenerated.certifier.nit = (invoice.certifierNIT) ? invoice.certifierNIT : "";
			templateGenerated.certifier.data = (invoice.certifier) ? invoice.certifier : "";
			const subtractHours = (timestamp: number, hours: number) => new Date(timestamp - hours * 60 * 60 * 1000).toISOString().split("T")[0];
			templateGenerated.invoice.date = (response.invoiceData.date) ? subtractHours(response.invoiceData.date, 6) : "";
			templateGenerated.invoice.accountingDate = (response.invoiceData.accountingDate) ? subtractHours(response.invoiceData.accountingDate, 6) : "";
			templateGenerated.invoice.number = (invoice.invoiceNumber) ? invoice.invoiceNumber : "";
			templateGenerated.invoice.serial = (invoice.serialNumber) ? invoice.serialNumber : "";
			templateGenerated.totalSubsidy = (invoice.totalSubsidio) ? invoice.totalSubsidio : 0;
			if (invoice.seller) {
				templateGenerated.seller.name = (invoice.seller.information.name) ? invoice.seller.information.name : "";
				templateGenerated.seller.city = (invoice.seller.information.city) ? invoice.seller.information.city : "";
				templateGenerated.seller.state = (invoice.seller.information.state) ? invoice.seller.information.state : '';
				templateGenerated.seller.street = (invoice.seller.information.street1) ? invoice.seller.information.street1 : "";
				templateGenerated.seller.nit = (invoice.seller.nit) ? invoice.seller.nit : "";
			}
			templateGenerated.total = response.invoiceData.totalCost + (response.invoiceData.totalTaxes ? response.invoiceData.totalTaxes : 0) + (response.invoiceData.totalExtraTax ? response.invoiceData.totalExtraTax : 0);
			// Math.abs(d.price - element.priceWithoutTax) < 0.000001 &&

			templateGenerated.totalIVAExempt = 0;
			templateGenerated.totalIDPExempt = 0;
			templateGenerated.hasRegularExtraTax = false;

			const gasExtraTaxes: { [key: number]: number } = {
			3: 4.70, // Gasolina Superior
			4: 4.14, // Gasolina Regular
			6: 1.30  // Diesel
			};

			invoice.items.forEach(element => {
				const detail = response.invoiceDetailData.find(d =>
					d.descriptionProduct === element.description.value &&
					d.price === element.priceWithoutTax &&
					d.quantity === element.quantity.value
				);
				const extraTaxAmount = detail?.extraTaxAmount ?? 0;
				

				templateGenerated.items.push(new InvoiceItemModel(
					element.quantity.value,
					element.priceWithoutTax,
					element.description.value,
					extraTaxAmount
				));
			});

			response.invoiceDetailData.forEach(element => {
					const extraTaxId = Number(element.extraTax);
					if (gasExtraTaxes[extraTaxId] !== undefined) {
						let iva = 0;
						let idp = 0;
						const quantity = Number(element.quantity || 0);
						const price = Number(element.price || 0);
						const totalPrice = price * quantity;
						templateGenerated.hasRegularExtraTax = true;
						idp = quantity * gasExtraTaxes[extraTaxId];
						iva = (totalPrice * 0.12);
						templateGenerated.totalIVAExempt += iva;
						templateGenerated.totalIDPExempt += idp;
					}
				}
			);


			// if(this.hasExtraTaxRegularConfig){
			// 	templateGenerated.hasRegularExtraTax = response.invoiceDetailData.some(
			// 		element => element.extraTax === 4
			// 	);
			// }
			console.log("IVA EX: ", templateGenerated.totalIVAExempt);
			console.log("IDP EX: ", templateGenerated.totalIDPExempt);
		} else {
			var invoiceBack = invoiceData as InvoiceBackendResponse;
			templateGenerated.type = InvoiceType.BACKEND;
			templateGenerated.currency = invoiceBack.backendData.currency;
			templateGenerated.client.name = (invoiceBack.backendData.name) ? invoiceBack.backendData.name : '';
			templateGenerated.client.nit = (invoiceBack.backendData.nit) ? invoiceBack.backendData.nit : '';
			templateGenerated.certifier.signature = '';
			templateGenerated.certifier.date = "";
			templateGenerated.certifier.nit = "";
			templateGenerated.certifier.data = "";
			templateGenerated.invoice.date = (invoiceBack.backendData.date) ? new Date(invoiceBack.backendData.date).toLocaleDateString('en-CA') : "";
			templateGenerated.invoice.accountingDate =
				(invoiceBack.backendData.accountingDate)
					? new Date(invoiceBack.backendData.accountingDate).toISOString().split("T")[0]
					: (invoiceBack.backendData.date)
						? new Date(invoiceBack.backendData.date).toISOString().split("T")[0]
						: "";
			templateGenerated.invoice.number = (invoiceBack.numero) ? invoiceBack.numero : "";
			templateGenerated.invoice.serial = (invoiceBack.serie) ? invoiceBack.serie : "";
			templateGenerated.seller.name = "";
			templateGenerated.seller.city = "";
			templateGenerated.seller.nit = "";
			templateGenerated.seller.state = '';
			templateGenerated.seller.street = "";
			templateGenerated.total = invoiceBack.backendData.totalCost + (invoiceBack.backendData.totalTaxes ? invoiceBack.backendData.totalTaxes : 0)
				+ (invoiceBack.backendData.totalExtraTax ? invoiceBack.backendData.totalExtraTax : 0);
			invoiceBack.backendDetailData.forEach(bd => {
				templateGenerated.items.push(new InvoiceItemModel(bd.quantity, bd.price, bd.descriptionProduct));
			});
		}
		if (this.inputs.warehouse.data.id == 3282 || this.inputs.warehouse.data.id == 3569) {
			templateGenerated.setPhrase(new ScenerySAT(0, 0));

		} else {
			if (invoiceData.taxRegime !== null && invoiceData.taxRegime !== undefined) {
				var scenary = invoiceData.taxRegime - 1 >= 0 ? invoiceData.taxRegime - 1 : 1;
				templateGenerated.setPhrase(new ScenerySAT(0, scenary));
			}
		}
		return templateGenerated;
	}

	refresh() {
		const currentUrl = this.router.url;
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate([currentUrl]);
		});
	}

	parseDateToMilliseconds(fechaStr: string): number | null {
		return DateUtil.parseDateToMilliseconds(fechaStr);
	}

	isReadyToSave(): boolean {
		const roundedPaid = Math.round(this.totals.paid * 100) / 100;
		const roundedToPay = Math.round(this.totals.toPay.sum * 100) / 100;
		return (
			!this.saving &&
			this.inputs.client.verified &&
			this.inputs.warehouse.verified &&
			this.alertMessage === '' &&
			(this.ordersSelected.length + this.productsList.length) > 0 &&
			(
				this.vendorBillingNits.length === 0 ||
				this.vendorBillingNitId != null
			) &&
			(this.options.selected === 'quotation' || roundedPaid >= roundedToPay ||
				// (this.options.selected === 'saleOrder' && (this.totals.creditAvailable >= this.totals.toPay.productList))
				(this.options.selected === 'saleOrder' || this.options.selected === 'advancePayment')
				
			)
		);
	}

	getCreditClient() {
		if (!this.inputs.client.data.id)
			return;

		this.service.getClientCredit(this.inputs.client.data.id).subscribe({
			next: (response) => {
				if (response.data.availableClientCredit != null) {
					this.totals.creditAvailable = response.data.availableClientCredit;
				} else {
					this.totals.creditAvailable = 0;
				}
			},
			error: (err: HttpErrorResponse) => {
				this.toastService.error(`No se puedo obtener el credito del cliente`, "Error")
			}
		});
	}

	get totalCreditAvailable() {
		// if (this.productList && this.productList.length > 0) {
		// 	const calculateTotal: number = this.productList.reduce(
		// 		(sum, item) => sum + item.quantity * item.price,
		// 		0
		// 	);
		// 	return (this.creditAvailable - calculateTotal).toFixed(2);
		// } else {
		// 	if (this.creditAvailable) {
		// 		return this.creditAvailable;
		// 	}
		// 	return 0.00;
		// }
		return 0.00;
	}

	onCheckboxChange(event: Event) {
		const checked = (event.target as HTMLInputElement).checked;

	}

	getQuantities() {
		if (!this.inputs.warehouse.data || !this.inputs.product.data) {
			return;
		}

		const productId = this.inputs.product.data.id;

		this.orderReservationService.getQuantityTransitProduct(productId).pipe(
			concatMap((responseTransit: ResponseObject) => {
				this.searchProduct.inTransit = responseTransit.data ?? 0;
				// Encadenamos el segundo servicio
				return this.orderReservationService.getQuantityReservationProduct(productId);
			})
		).subscribe({
			next: (responseReserved: ResponseObject) => {
				this.searchProduct.inReserved = responseReserved.data ?? 0;
				this.applyReservation(); // 👈 ahora se ejecuta con ambos valores correctos
			},
			error: (error: HttpErrorResponse) => {
				console.error('Error al obtener cantidades:', error);
				this.searchProduct.inTransit = 0;
				this.searchProduct.inReserved = 0;
			}
		});
	}

	applyReservation() {
		let newExistence = this.searchProduct.stock;
		let newTransit = this.searchProduct.inTransit;

		// Primero restamos de existencia
		if (this.searchProduct.inReserved <= newExistence) {
			newExistence -= this.searchProduct.inReserved;
		} else {
			// Si no alcanza la existencia, restamos todo lo que tiene y el resto va al tránsito
			const remaining = this.searchProduct.inReserved - newExistence;
			newExistence = 0;

			// Restar del tránsito el resto de la reserva
			if (remaining <= newTransit) {
				newTransit -= remaining;
			} else {
				// Si tampoco alcanza, el tránsito queda en 0
				newTransit = 0;
			}
		}
		this.searchProduct.stockTemp = newExistence;
		this.searchProduct.inTransitTemp = newTransit;
	}

	saveGeographicLocation(invoice) {
		if (!this.checkGeographicMap) {
			return;
		}
		let invoiceId = null;
		let isBackend = false;

		if (invoice.documentId == null) {
			if (invoice.data.gfaceData) {
				return;
			} else {
				if (invoice.data.backendData) {
					if (invoice.data.backendData.id) {
						invoiceId = invoice.data.backendData.id;
						isBackend = true;
					}
				} else {
					return;
				}
			}
		} else {
			invoiceId = invoice.documentId
		}

		if (invoiceId == null) {
			return;
		}

		this.geographicRouteService.getCurrentLocation()
			.then((position) => {
				const request = {
					warehouse: this.inputs.warehouse.data.id,
					latitude: position.latitude,
					longitude: position.longitude,
					date: Date.now(),
					invoiceId: invoiceId
				};

				this.geographicRouteService.createRoutePoint(request, isBackend).subscribe({
					next: () => console.log('Punto de ruta registrado exitosamente'),
					error: () => console.warn('No se pudo registrar el punto de ruta')
				});
			})
			.catch(() => console.warn('No se pudo obtener la ubicación del dispositivo'))
	}

	saveAssociationExitNote(invoice) {
		if (invoice.documentId == null) {
			return;
		}

		this.associationExitNoteService.generateAssociationSale(invoice.documentId).subscribe({
			next: (response: ResponseObject) => {
			},
			error: (error: HttpErrorResponse) => {
				console.log("Error al generar la assocaicion de la nota de salida");

			}
		});
	}

	getDestinationWarehouse() {
		if (!this.inputs.warehouse.verified) {
			return;
		}
		this.destinationsWarehouse = [];
		this.lastDestinationWarehouse = null;
		this.destinationService.getWarehouseDestinationsByEffectiveDateAndWarehouse(this.inputs.warehouse.data.id, new Date().toLocaleDateString('en-CA')).subscribe({
			next: (response: ResponseObject) => {
				this.destinationsWarehouse = response.data;
				if (this.destinationsWarehouse.length > 0) {
					this.lastDestinationWarehouse = this.destinationsWarehouse[this.destinationsWarehouse.length - 1];
				}
			},
			error: (error: HttpErrorResponse) => {

			}
		});
	}

	getVendorBillingNits(vendorId: number): void {
		this.vendorBillingNits = [];
		this.vendorBillingNitId = null;

		if (!vendorId) {
			return;
		}
		this.loadingVendorBillingNits = true;

		this.vendorBillingNitService
			.getVendorBillingNitByIdValidateAdministrative(vendorId)
			.subscribe({
				next: (response: ResponseObject) => {

					this.vendorBillingNits = response.data || [];

					this.loadingVendorBillingNits = false;

					if (this.vendorBillingNits.length === 1) {
						this.vendorBillingNitId =
							this.vendorBillingNits[0].id;
					}
				},
				error: (error: HttpErrorResponse) => {

					this.loadingVendorBillingNits = false;

					this.vendorBillingNits = [];
					this.vendorBillingNitId = null;

					this.toastService.error(
						error.error?.message ||
						"Error al obtener los NIT de facturación"
					);
				}
			});
	}

	openClientOptionsModal(): void {

		const client = this.inputs.client?.data;

		if (!client?.id) {
			this.toastService.info(
				'Debes seleccionar un cliente primero'
			);
			return;
		}

		// Si el cliente seleccionado tiene codigo VCF se abre el modal para crear cliente
		if (client.code?.trim().toUpperCase() === 'VCF') {
			this.showClientCfModal = true;
			return;
		}

		// Si es otro se haber el modal del nit
		this.showVendorBillingNitModal = true;
	}

	closeVendorBillingNitModal(updated: boolean): void {

		this.showVendorBillingNitModal = false;

		if (updated && this.inputs.client?.data?.id) {

			this.getVendorBillingNits(
				this.inputs.client.data.id
			);

		}
	}

	closeClientCfModal(created: boolean): void {

		this.showClientCfModal = false;

		if (created) {
			this.reloadClients();
		}
	}

	reloadClients(): void {
		this.service.getClients().subscribe({
			next: (response: any) => {

				this.vendors = response.data || [];
				this.filterClients = this.vendors;

			},
			error: (error: HttpErrorResponse) => {

				this.toastService.error(
					error.error?.message ||
					'No se pudieron actualizar los clientes'
				);

			}
		});
	}

	loadProductsByWarehouse(): void {
		const warehouseId = this.inputs.warehouse.data?.id;

		if (!warehouseId) {
			this.products = [];
			this.filterProducts = [];
			return;
		}

		this.service.getProductsFilteredByFavorite('', warehouseId).subscribe({
			next: (response: ResponseObject) => {
				this.products = response.data ?? [];
				this.filterProducts = this.products;

				// Conserva tu filtro de productos propios si aplica
				this.filterProductsCp();
			},
			error: (error: HttpErrorResponse) => {
				console.error(error);
				this.products = [];
				this.filterProducts = [];
			}
		});
	}

	getAdvancesClient(clientId: number): void {
		this.advancesClient = [];

		this.payment.methods.advance.advanceId = null;
		this.payment.methods.advance.advance = null;
		this.payment.methods.advance.amount = null;
		this.payment.methods.advance.validated = false;

		if (!clientId) {
			return;
		}

		this.loadingAdvancesClient = true;

		this.bankService.getAdvancesClient(clientId).subscribe({
			next: (response: any) => {

				this.advancesClient = response?.data ?? [];

				this.advancesClient.sort((a, b) => {
					const dateA = new Date(a.date).getTime();
					const dateB = new Date(b.date).getTime();

					return dateB - dateA;
				});

				this.loadingAdvancesClient = false;
			},
			error: (error: HttpErrorResponse) => {

				this.advancesClient = [];
				this.loadingAdvancesClient = false;

				this.toastService.error(
					error.error?.message ||
					'Error al obtener los anticipos del cliente'
				);
			}
		});
	}

	selectAdvanceClient(advanceId: number): void {

		const method = this.payment.methods.advance;

		method.advance = this.advancesClient.find(
			advance =>
				Number(advance.docId ?? advance.id) === Number(advanceId)
		) ?? null;

		// Al cambiar de anticipo limpiamos el monto anterior
		method.amount = null;
		method.validated = false;

		this.updateChange();
	}
}
